import { render, staticRenderFns } from "./My-Home.vue?vue&type=template&id=9c401c94&scoped=true&"
import script from "./My-Home.vue?vue&type=script&lang=js&"
export * from "./My-Home.vue?vue&type=script&lang=js&"
import style0 from "./My-Home.vue?vue&type=style&index=0&id=9c401c94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c401c94",
  null
  
)

export default component.exports